import React from 'react';
import './Loader.css'; // Asegúrate de tener el archivo CSS con los estilos anteriores

const Loader = () => {
  return <div class="loader-overlay">
  <div class="loader"></div>
    </div>;
};

export default Loader;
